<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="pre2"></a><a id="page_v"><strong><span class="red">sa•voir faire</span></strong> \<span class="subscript">I</span> sav-<span class="subscript">I</span> wär-<sup class="superscript">I</sup>fer\ <em>n.m.</em> <strong>1:</strong> Know-how. French <em>savoir-faire</em>, literally, knowing (<em>savoir</em>) how to do (<em>faire</em>). <strong>2:</strong> Competence, experience. <strong>3:</strong> The ready knowledge of the right course of action: knowing what to do and say and when and how to do so. <strong>4:</strong> <em>Habileté dans un art quelconque.</em> 1784 <em>“Pour gagner du bien, le savoir-faire vaut mieux que le savoir</em>.<em>”</em> In order to succeed, savoir faire is more important than knowledge. Pierre Augustin Caron de Beaumarchais, <em>Le Mariage de Figaro,</em> V, 3. <strong>5:</strong> To be up to snuff with wit of a thing or two. 1815 “He had great confidence in his <em>savoir-faire.</em>” Sir Walter Scott, <em>Guy Mannering</em>. <strong>6:</strong> Operating knowledge of business sense and sensibility.</a></p><a id="page_v">
</a><p class="noindent"><a id="page_v"></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm5_pre2.vue?50e82c80